module.exports = __webpack_public_path__ + "static/breastfeeding_img2@2x-cfe6c69cdc75a1aafae4c2f8e004374f.png";